import React from 'react'
import ServiceDetails from '../Components/ServiceDetails/ServiceDetails'
import DiamondImg from '../Assests/Images/carousal-diamond.jpg'

export default function ServiceDiamondMarvel() {
    return (
        <>
            <ServiceDetails
                ServiceName ={"Diamond Marble Floor Polish"}
                Description ={<p>Marble is one of the most beautiful natural stone that you can choose for your floors. It is durable, naturally resistant to stains and easy to clean. However  how durable it is, over years of use, it can get dirty, lose its polish and shine. This can leave you with dull floors that might still look nice, but are nowhere near as beautiful as they were when they were shiny and lustrous. <br/><br/> Marble polishing is the best way to buff away scratches, minute damage and normal wear and tear on your marble floors or  other marble surfaces. The marble is an excellent flooring choice for both traditional and modern homes, but it does require maintenance. For our marble floor polishing service in London, we use the best products and techniques in order to restore the gleam that originally drew you to marble flooring.</p>}
                ServiceImage={<img src={DiamondImg} alt='DiamondImg'></img>} />

      
        </>
    )
}
